<script>
    import R, {LOADER} from "../lib/requests";
    import Modal from "../components/modal/Modal.svelte";
    import TableHeader from "../components/TableHeader.svelte";
    import CheckboxIcon from "../components/icons/CheckboxIcon.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import {setFocusTo, sort} from "../lib/lib";

    export let selected = [];
    export let callbackHandler;

    const tableColumns = [
        {key: 'selected', title: 'checkbox', sortable: true, sort_way: 'ASC'},
        {key: 'name', title: 'NAME', sortable: true},
    ];

    let hotels = null;
    let name = '';
    let timer;

    const load = () => {
        const onSuccess = result => {
            hotels = result;
            hotels.map(item => {
                item.selected = selected.indexOf(item.id) > -1;
            });
            hotels = sort(hotels, 'selected', true);
        }

        const onFailure = err => {
        };

        R.handle(R.hotel.index, {name}, onSuccess, onFailure, LOADER.POPUP);
    }

    const onKeyUp = (event) => {
        if (event.key === 'Enter') {
            name = event.target.value;
            load();
        }
    }

    const onColumnSort = ({detail: column}) => {
        hotels = sort(hotels, column.key, column.sort_way === 'ASC');
    }

    const onClick = (hotel) => {
        hotel.selected = !hotel.selected;
        if (hotel.selected) {
            selected = [...selected, hotel.id];
        } else {
            selected = selected.filter(x => x != hotel.id);
        }
        hotels = hotels;
    }

    const selectAll = () => {
        selected = [];
        hotels.map(item => {
            item.selected = true;
            selected = [...selected, item.id];
        });
        hotels = hotels;
    }

    const selectNone = () => {
        selected = [];
        hotels.map(item => {
            item.selected = false;
        });
        hotels = hotels;
    }

    const applySelection = () => {
        callbackHandler(selected);
    }

    const close = () => {
        callbackHandler();
    }

    setFocusTo("searchName");
    load();
</script>

{#if hotels}
    <Modal title="Select Hotels" on:close="{ close }">
        <div slot="body">
            <div class="tools-box mb-3">
                <div class="input-group me-1">
                    <input type="text" class="form-control" id="searchName" bind:value="{ name }" on:keyup="{ onKeyUp }"
                           placeholder="find hotel">
                    <button class="btn btn-default" on:click={ load }>
                        <AppIcon icon="search" size="16"/>
                    </button>
                </div>
                <button class="btn btn-default btn-flex line-height-1" title="select all" on:click="{ selectAll }">
                    <CheckboxIcon checked/>
                </button>
                <button class="btn btn-default btn-flex line-height-1" title="select none" on:click="{ selectNone }">
                    <CheckboxIcon/>
                </button>
            </div>
            <table class="table table-list table-list-border">
                <TableHeader {tableColumns} on:sort={ onColumnSort }/>
                <tbody>
                {#each hotels as hotel}
                    <tr class="row-hover pointer" on:click="{ () => onClick(hotel) }">
                        <td class="checkbox-column">
                            {#if hotel.selected}
                                <CheckboxIcon size="medium" absolute checked/>
                            {/if}
                        </td>
                        <td class:not-active="{ hotel.is_active < 1}">
                            { hotel.name }
                        </td>
                    </tr>
                {/each}
                </tbody>
            </table>
            {#if selected.length}
                <div class="mt-1">
                    { selected.length } hotels selected
                </div>
            {/if}
            <div class="text-end">
                <div class="btn btn-link me-2" on:click="{ () => close() }">Close</div>
                <button class="btn btn-primary px-4" on:click="{ applySelection }">OK</button>
            </div>
        </div>
    </Modal>
{/if}